const Line = ({width}) => {
    return ( 
        <section style= {{borderTop: "2px solid #574D68", height: "15px", width: width, margin: "0 auto"}}></section>
     );
}
 
export default Line;